import React, {Component} from "react";
import {FormattedMessage} from "react-intl";

const optionsInEN = [
    {text : "Today" , value : 1},
    {text : "This Week" , value : 2},
    {text : "This Month" , value : 3},
    {text : "This Year" , value : 4},
    {text : "Date Range" , value : 5},
    {text : "All" , value : 6}
];
const optionsInJP = [
    {text : "今日" , value : 1},
    {text : "今週" , value : 2},
    {text : "今月" , value : 3},
    {text : "今年" , value : 4},
    {text : "期間" , value : 5},
    {text : "全て" , value : 6}
];

const FromToDateToggle = (props) => {
    return(
        <div>
            <div className="col-md-1 no-padding">
                <div className="all-order-header-label">
                    <FormattedMessage id="app.order.history.date.from"
                                      defaultMessage="From"
                                      description=""/>
                </div>
            </div>
            <div className="col-md-2 no-padding-right">
                <input onChange={props.handlePeriodChange} className="all-order-header-search-input" max="9999-12-31"
                       name="from" type="date"/>
            </div>
            <div className="col-md-1">&nbsp;</div>
            <div className="col-md-1 no-padding">
                <div className="all-order-header-label no-padding">
                    <FormattedMessage id="app.order.history.date.to"
                                      defaultMessage="To"
                                      description=""/>
                </div>
            </div>
            <div className="col-md-2 no-padding-right">
                <input onChange={props.handlePeriodChange} className="all-order-header-search-input" max="9999-12-31"
                       name="to" type="date"/>
            </div>
        </div>
    )
};

class CancelledOrdersTableHeader extends Component{

    constructor(props) {
        super(props);
        this.state = {
            period : null
        };

        this.handlePeriodChange = this.handlePeriodChange.bind(this);
    }

    handlePeriodChange = (periodChangeEvent) => {
        if(periodChangeEvent.target.name == "period-input"){
            this.setState({
                period : periodChangeEvent.target.value
            },()=>{
                if(this.state.period === "All"){
                    this.props.getAllOrders(0,5);
                }
            });
        }
        if(periodChangeEvent.target.name == "from"){
            this.props.setSearchTimeRange("from",periodChangeEvent.target.value);
        }else if(periodChangeEvent.target.name == "to"){
            this.props.setSearchTimeRange("to",periodChangeEvent.target.value);
        }else {
            this.props.setSearchTimePeriod(periodChangeEvent.target.value);
        }
    };

    render(){
        return(
                <div className="row">
                    <div className="col-md-6"></div>
                    <div className="col-md-3 text-right">
                        注文バッチ番号で検索
                    </div>
                    <div className="col-md-3">
                        <input type="text" className="cancelled-order-search" placeholder="Wxxxxxxxxxxxxxx" onChange={this.props.onSearchInputChange}/>
                    </div>
                    <div className="col-md-12">&nbsp;</div>
                    <br/>
                </div>
        )
    }
}

export default CancelledOrdersTableHeader;



// WEBPACK FOOTER //
// ./src/components/Admin/Sales/CancelledOrder/CancelledOrdersTable/CancelledOrdersTableHeader.js